import React, { useState, useContext } from "react";
import themeContext from "../../../../context/theme/ThemeContext";

const DownloadReportIcon = ({ downloaded }) => {
  const [hover, setHover] = useState(false);
  const { themeName } = useContext(themeContext);

  const getColor = () => {
    if (downloaded) return "#00A651";     // green
    if (hover) return "#147BFF";          // blue on hover
    return themeName === "light" ? "#000000" : "#DADADA"; // black for light theme, grey for others
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 16 16"
      fill="none"
      className="study-list-report-icons"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <path
        d="M14 11V14H2V11H0V14C0 15.1 0.9 16 2 16H14C15.1 16 16 15.1 16 14V11H14ZM13 7L11.59 5.59L9 8.17V0H7V8.17L4.41 5.59L3 7L8 12L13 7Z"
        fill={getColor()}
      />
    </svg>
  );
};

export default DownloadReportIcon;
